import { styled } from '@mui/material';

import { Info } from '../../ui-kit/info/info.component';
import { shouldForwardProps } from '../../utils/mui-styled.utils';
import {
	getGradientLayerPositions,
	HEADER_HEIGHT_DESKTOP,
	HEADER_HEIGHT_MOBILE,
	MAX_WIDGET_WIDTH,
} from '../../utils/sizes.utils';

interface WrapperSectionProps {
	gradientRotationValue: number;
	isMobile: boolean;
	isFullScreen: boolean;
}

export const StyledWidgetWrapperInfo = styled(Info, {
	shouldForwardProp: shouldForwardProps(['isMobile']),
})<{ isMobile: boolean }>(
	({
		theme: {
			palette: { sizes, transitionConfig },
		},
		isMobile,
	}) => ({
		zIndex: 2,
		position: 'absolute',
		top: isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP,
		left: `calc(${sizes.size_1}% - ${sizes.size_1}px)`,
		right: `calc(${sizes.size_1}% - ${sizes.size_1}px)`,
		'&.notification-enter': {
			top: `-${isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP}px`,
		},
		'&.notification-enter-active': {
			top: isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP,
			transition: `all ${transitionConfig.transitionInDuration}ms`,
		},
		'&.notification-exit': {
			top: isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP,
		},
		'&.notification-exit-active': {
			top: `-${isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP}px`,
			transition: `all ${transitionConfig.transitionOutDuration}ms`,
		},
	}),
);

export const StyledWidgetWrapperChat = styled('div')(
	({
		theme: {
			palette: {
				colorScheme: {
					customStyle: { mainChat },
				},
			},
		},
	}) => ({
		position: 'relative',
		width: '100%',
		height: '100%',
		overflow: 'hidden',
		maxWidth: MAX_WIDGET_WIDTH,
		margin: '0 auto',
		...mainChat,
	}),
);

export const StyledWidgetWrapperSection = styled('section', {
	shouldForwardProp: shouldForwardProps(['isMobile', 'isFullScreen', 'gradientRotationValue']),
})<WrapperSectionProps>(
	({
		theme: {
			palette: {
				borderRadius,
				widgetBackground,
				visualConfig,
				colorScheme: { colorVariables },
			},
		},
		isMobile,
		isFullScreen,
		gradientRotationValue,
	}) => ({
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		position: 'relative',
		borderRadius: isMobile || isFullScreen ? 0 : borderRadius.widget,
		border: `1px solid ${colorVariables.colorLightShadowNoOpacity}`,
		'&:before': {
			content: '""',
			position: 'absolute',
			top: getGradientLayerPositions(visualConfig.animateBackground),
			bottom: getGradientLayerPositions(visualConfig.animateBackground),
			left: getGradientLayerPositions(visualConfig.animateBackground),
			right: getGradientLayerPositions(visualConfig.animateBackground),
			transition: 'transform 0.4s ease-in-out',
			transform: `rotate(${gradientRotationValue}deg)`,
			zIndex: -1,
			...widgetBackground.gradient,
		},
		...widgetBackground.overlay,
		...((isMobile || isFullScreen) && { border: 'none' }),
	}),
);
